import script from "./ReportPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReportPage.vue?vue&type=style&index=0&id=af9585cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9585cc"]])

export default __exports__